import request from '@/utils/request'

export function requestGet(url,params) {
    return request({
      url,
      method: 'get',
      params
    })
  }
  export function requestPost(url,data) {
    return request({
      url,
      method: 'post',
      data
    })
  }